import React, { useEffect, useState } from 'react'
import DashboardMenu from '../dashboard/DashboardMenu'
import { GetLiveClassService } from '../../services/LiveClassServices';
import { ButtonOutlinedAutoWidth } from '../../components/button'
import { DatePicker } from 'antd';
import { useNavigate } from 'react-router-dom';
import {FiChevronRight,FiChevronLeft} from 'react-icons/fi';
import { IconButton } from '@material-ui/core';
import { AiOutlineEdit } from 'react-icons/ai';
import { FaUsersBetweenLines } from "react-icons/fa6";
import moment from 'moment';

function LiveClassList() {

  const navigator = useNavigate()

  const [data, setdata] = useState({pagination:{total:0}});
  const [page,setpage] = useState(1)
  const [search,setsearch] = useState({text:'',from_date:'',from_date1:'',to_date:'',to_date1:''})

  useEffect(()=>{
    getData()
  },[page])

  async function getData() {
    const response = await GetLiveClassService(page,search?.text,search?.from_date1,search?.to_date1)
    setdata(response?.data)
  }

  async function applyFilter(){
    setsearch({...search,activate:true})
    setpage(1)
    const response =  await GetLiveClassService(1,search?.text,search?.from_date1,search?.to_date1)
    setdata(response?.data)
  }

  async function resetfilter(){
    setsearch({text:'',from_date:'',to_date:'',from_date1:'',to_date1:'',activate:false})
    setpage(1)
    const response =  await GetLiveClassService(1,'','','')
    setdata(response?.data)
  }

    
  return (
    <div className='md:h-screen md:min-h-screen md:max-h-screen md:overflow-hidden'>
      <div className='md:flex'>
        <DashboardMenu />
        <div className='md:w-[100%] px-4 py-4 md:w-[86%] relative'>
            <div className='md:flex w-full -mt-1 border-b justify-between pb-1'>
                <div className='flex items-center justify-between'>
                  <h6 className='font-[800] text-[13px]'>Total Live Class ({data?.pagination?.total})</h6>
                  <div className='flex items-center md:hidden text-[12px]'>

                    <h6 className='mr-2 font-[600]'>{page == 1 ? data?.datas?.length > 0 ? 1 : 0 : (page - 1) * data?.pagination?.limit } - {data?.pagination?.limit} of {data?.pagination?.total}  </h6>

                    <IconButton onClick={()=>{page > 1 ? setpage(page-1) : console.log('')}}><FiChevronLeft className={`${page === 1 ? 'opacity-50' : 'opacity-100'}`}  size={16} /></IconButton>
                    <IconButton onClick={()=>{ page < data?.pagination?.totalPages  ? setpage(page+1) : console.log('')}}><FiChevronRight className={`${(data?.pagination?.totalPages === page || data?.datas?.length === 0) ? 'opacity-50 ' : 'opacity-100'}`}  size={16} /></IconButton>
                  </div> 
                </div> 

                <div className='flex flex-wrap items-center text-[12px]'>

                    <div className='hidden md:flex items-center'>

                    <h6 className='mr-2 font-[600]'>{page == 1 ? data?.datas?.length > 0 ? 1 : 0 : (page - 1) * data?.pagination?.limit } - {data?.pagination?.limit} of {data?.pagination?.total}  </h6>

                    <div>
                    <IconButton onClick={()=>{page > 1 ? setpage(page-1) : console.log('')}}><FiChevronLeft className={`${page === 1 ? 'opacity-50' : 'opacity-100'}`}  size={16} /></IconButton>
                    <IconButton onClick={()=>{ page < data?.pagination?.totalPages  ? setpage(page+1) : console.log('')}}><FiChevronRight className={`${(data?.pagination?.totalPages === page || data?.datas?.length === 0) ? 'opacity-50 ' : 'opacity-100'}`}  size={16} /></IconButton>

                    </div>
                    </div>  
                    <DatePicker  size='small' style={{fontSize:'11px'}} ampm={false} placeholder='From Date' className='text-[11px] py-[2.6px]  w-28 border-slate-300 mr-2'  value={search?.from_date} onChange={(v,v1) => {console.log('v na',new Date(v).toLocaleDateString());setsearch({...search,from_date:v,from_date1:v1})}} /> 

                    <DatePicker size='small' style={{fontSize:'11px'}} ampm={false} placeholder='To Date' className='text-[11px] py-[2.6px]  w-28 border-slate-300 mr-2'  value={search?.to_date} onChange={(v,v1) => {console.log('v na',new Date(v).toLocaleDateString());setsearch({...search,to_date:v,to_date1:v1})}} /> 

                    
                    <div className='mr-2 mt-1 md:mt-0'>
                        

                    <input  id="search_text" placeholder='Search text' type='text' value={search.text} onChange={(e)=>setsearch({...search,text:e.target.value})} className='border py-[3px] focus:ring-0 focus:outline-0 text-[14px]  w-[100px] px-1 rounded-md border-slate-300' />
                

                    </div>  
                    <div className='mr-2 mt-1 md:mt-0'>
                    <ButtonOutlinedAutoWidth btnName="Apply Filter" onClick={()=>applyFilter()} /> 
                    </div>
                    <div className='mr-2 mt-1 md:mt-0'>
                    <ButtonOutlinedAutoWidth btnName="Reset Filter" onClick={()=>resetfilter()} /> 
                    </div>
                   
                </div>
            </div>

            <div className='mb-[50px]'>
                            
                {data?.datas?.length === 0 &&
                <div className='grid place-items-center mt-20  items-center justify-center'>
                    <img src={'https://fidecrmfiles.s3.amazonaws.com/NoDataFound1.png'} className='w-40 h-40 object-contain' /> 
                    <h6 className='font-bold text-[14px] -mt-10'>No data found</h6>
                    <h6 className='font-[500] w-[70%] text-center text-slate-700 text-[12.5px] -mt-2'>Oops we couldn't find any data based on your current stage please add the data to see list here.</h6>
                </div>}

                <div className='w-[100%]'>
                    {data?.datas?.length > 0 &&
                     <>
                     {/* Desktop / tablet table */}
                     <div className='hidden md:block md:max-h-[85vh] mt-4 border-t md:overflow-y-auto border-l border-r border-b'>
                          <div className='sticky top-0 z-50 flex w-full bg-white py-[-5px] border-b border-slate-200 relative'>
                              <h6  className='top-0 bg-white z-50 text-[12px] w-[50px] px-2 py-1 font-[600] text-slate-800 border-r flex items-center justify-center'>Sl No</h6>
                              <h6 className='sticky top-0 z-50 text-[12px] flex-1 px-2 py-1 font-[600] text-slate-800 border-r'>Topic</h6>
                              <h6 className='sticky top-0 z-50 text-[12px] flex-[2] px-2 py-1 font-[600] text-slate-800 border-r'>Description</h6>
                              <h6 className='sticky top-0 z-50 text-[12px] flex-1 px-2 py-1 font-[600] text-slate-800 border-r'>Teacher Name</h6>
                              <h6 className='sticky top-0 z-50 text-[12px] flex-1 px-2 py-1 font-[600] text-slate-800 border-r'>Qualification</h6>
                              <h6 className='sticky top-0 z-50 text-[12px] flex-1 px-2 py-1 font-[600] text-slate-800 border-r'>Start Time</h6>
                              <h6 className='sticky top-0 z-50 text-[12px] flex-1 px-2 py-1 font-[600] text-slate-800 border-r'>Duration</h6>
                              <h6 className='sticky top-0 z-50 text-[12px] flex-1 px-2 py-1 font-[600] text-slate-800 border-r'>Created At</h6>
                              <h6 className='sticky top-0 z-50 text-[12px] w-[80px] px-2 py-1 font-[600] text-slate-800'>Actions</h6>
                          </div>
                          {data?.datas?.map((d,i)=>(
                          <div key={d?._id || i} className='flex w-full bg-white py-[-5px] border-b border-slate-200 relative'>
                              <h6  className='bg-white text-[12px] w-[50px] px-2 py-1 font-[500] border-r flex justify-center'>{(page > 1 ? i+1+ (data?.pagination?.limit * (page - 1)) : i+1 )}</h6>
                              <h6 className='text-[12px] flex-1 px-2 py-1 font-[500] border-r'>{d?.topic}</h6>
                              <h6 className='text-[12px] flex-[2] px-2 py-1 font-[500] border-r'>{d?.description}</h6>
                              <h6 className='text-[12px] flex-1 px-2 py-1 font-[500] border-r'>{d?.teacher_name}</h6>
                              <h6 className='text-[12px] flex-1 px-2 py-1 font-[500] border-r'>{d?.qualification}</h6>
                              <h6 className='text-[12px] flex-1 px-2 py-1 font-[500] border-r'>{d?.start_time}</h6>
                              <h6 className='text-[12px] flex-1 px-2 py-1 font-[500] border-r'>{d?.duration}</h6>
                              <h6 className='text-[11px] flex-1 px-2 py-1 font-[500] border-r'>{moment(d?.createdAt)?.format('lll')}</h6>
                              <h6 className='flex text-[12px] w-[80px] text-slate-500 px-2 py-1 font-[500]'>
                                <AiOutlineEdit onClick={()=>navigator('edit',{state:d})} className='mr-2' />
                                <FaUsersBetweenLines onClick={()=>navigator('attendees',{state:d})} className='mr-2' />
                              </h6>
                          </div>))}
                     </div>

                     {/* Mobile card list */}
                     <div className='md:hidden mt-3 space-y-2'>
                        {data?.datas?.map((d,i)=>(
                          <div key={d?._id || i} className='border rounded-md p-3 bg-white'>
                            <div className='flex items-start justify-between'>
                              <h6 className='text-[13px] font-[700]'>{d?.topic}</h6>
                              <div className='flex items-center -mr-1.5'>
                                <span className='p-2 cursor-pointer'><AiOutlineEdit size={17} onClick={()=>navigator('edit',{state:d})} /></span>
                                <span className='p-2 cursor-pointer'><FaUsersBetweenLines size={16} onClick={()=>navigator('attendees',{state:d})} /></span>
                              </div>
                            </div>

                            {d?.description && <h6 className='text-[11px] text-slate-600 mt-1'>{d?.description}</h6>}

                            <div className='grid grid-cols-2 gap-x-3 gap-y-1 mt-2 text-[11px]'>
                              <h6><span className='font-[600]'>Teacher:</span> {d?.teacher_name || '-'}</h6>
                              <h6><span className='font-[600]'>Qualification:</span> {d?.qualification || '-'}</h6>
                              <h6><span className='font-[600]'>Start Time:</span> {d?.start_time || '-'}</h6>
                              <h6><span className='font-[600]'>Duration:</span> {d?.duration || '-'}</h6>
                            </div>

                            <h6 className='text-[10px] text-slate-400 mt-2'>Created {moment(d?.createdAt)?.format('lll')}</h6>
                          </div>
                        ))}
                     </div>
                     </>}
                </div>
            </div>  

      </div>

      </div>
    </div>    
  )
}

export default LiveClassList